import { observable, computed, action, IObservableArray } from "mobx";

import { CollectionStoreImpl } from "./CollectionStore";
import { WizardStore, IWizardStore } from "./AppStore";
import { Strings } from "../Stores/StringsStore";

export class CollectionMoveWizardStore extends WizardStore implements IWizardStore {

	constructor(public collectionStore: CollectionStoreImpl) {
		super();
	}


	/**
  * Open the wizard for moving collections.
  */
	open = (): void => {
		this.wizardCaption = Strings.documentManagement.collections.moveCollectionCaption;
		this.wizardInformation = Strings.documentManagement.collections.moveCollectionText;
		this.collectionStore.moveTreeViewStoreCollections.inMoveMode = true;
		this.isOpen = true;
	}

	/**
   * Callback for confirming the wizard operation.
   */
	@action onConfirmWizard = () => {
		this.collectionStore.moveTreeViewStoreCollections.moveCollectionItems();
		this.isOpen = false;
	}

	/**
	* Callback fro canceling the wizard operation.
	*/
	@action onCancelWizard = () => {
		this.isOpen = false;
		this.collectionStore.moveTreeViewStoreCollections.model.subCollections.clear();
		this.collectionStore.resetMoveMode();

	}

}